import type { AnyFormApi } from '@tanstack/react-form';
import { useStore } from '@tanstack/react-form';
import { useBlocker } from '@tanstack/react-router';

export function useNavigationBlocker(form: AnyFormApi) {
  const isDefaultValue = useStore(
    form.store,
    (state) => !Object.values(state.fieldMeta).some((meta) => meta !== undefined && !meta.isDefaultValue),
  );

  useBlocker({
    shouldBlockFn: () => {
      if (isDefaultValue) return false;

      // eslint-disable-next-line no-restricted-globals, no-alert
      const shouldLeave = confirm('Ihre Änderungen gehen verloren. Wirklich ohne Speichern fortfahren?');

      return !shouldLeave;
    },
    enableBeforeUnload: !isDefaultValue,
  });
}
